import React, { useState, useEffect } from 'react';
import { connect, useSelector } from 'react-redux';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { StyledMoreVertIcon } from './EllipsesMenu.styled';
import Tooltip from '@material-ui/core/Tooltip';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import BuildIcon from '@material-ui/icons/Build';
import PrintIcon from '@material-ui/icons/Print';
import PaletteIcon from '@material-ui/icons/Palette';
import InfoIcon from '@material-ui/icons/InfoOutlined';
import AnnouncementIcon from '@material-ui/icons/Announcement';
import AppsIcon from '@material-ui/icons/Apps';
import DeviceHubIcon from '@material-ui/icons/DeviceHub';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import { AnnouncementDialog } from 'elements/CustomHeaderButtons/AnnouncementDialog';
import { fetchLateEntryMenuFlag, setLateEntryStatus, setCurrentView } from 'journeys/portal/Home/Home.actions';
import Badge from '@material-ui/core/Badge';

const EllipsesMenu = ({ testEquipmentSection, dpsSection, printButtonVisible, headerPrintButtonHandler, setColorLedgerVisible, headerLogOutButtonHandler, isMRATOnline, currentAppView, headerInfoButtonHandler, onClassicAppClick, bpRegionNameAlias, IsLateEntry, setLateEntryUserStatus, setCurrentAppView }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [clickedButton, setClickedButton] = useState(null);
    const [isLateEntryMenu, setIsLateEntryMenu] = useState(false);
    const isNonMoFeatureEnabled = useSelector(({ Home }) => Home.isNonMoFeatureEnabled);
    useEffect(() => {
        if (bpRegionNameAlias) {
            fetchLateEntryMenuFlag(bpRegionNameAlias).then(flag => {
                setIsLateEntryMenu(flag);
            });
        }
    }, [bpRegionNameAlias, IsLateEntry]);
    const useTooltipStyles = makeStyles({
        tooltip: {
            fontSize: '0.8rem',
            backgroundColor: '#fff',
            border: '1px solid black',
            color: 'rgba(0, 0, 0, 0.87)',
            margin: '2px',
        },
    });

    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleItemClick = (handler) => {
        handleMenuClose();
        if (handler) handler();
    };
    const handleLateEntryClick = () => {
        setLateEntryUserStatus(true);
        setCurrentAppView('lateEntryHome');
    };

    const menuItems = [
        (currentAppView === 'home' || currentAppView === 'lateEntryHome') && {
            id: '1',
            label: 'Announcements',
            icon: <AnnouncementIcon />,
            notification: true,
            onClick: () => {
                setClickedButton('Announcements');
                setDialogOpen(true);
            },
        },
        (currentAppView === 'lateEntryHome') && {
            id: '2',
            label: 'Classic App',
            icon: <AppsIcon />,
            onClick: onClassicAppClick,
        },
        (currentAppView !== 'home' && currentAppView !== 'lateEntryHome') && {
            id: '3',
            label: 'Color Legend',
            icon: <PaletteIcon />,
            onClick: () => setColorLedgerVisible(true),
        },
        dpsSection && {
            id: '4',
            label: 'Device Performance Standard',
            icon: <DeviceHubIcon />,
            onClick: dpsSection,
        },
        (isLateEntryMenu && isMRATOnline && !isNonMoFeatureEnabled && currentAppView !== 'lateEntryHome' && currentAppView === 'home') && {
            id: '5',
            label: 'Late Entry',
            icon: <AccessTimeIcon />,
            onClick: handleLateEntryClick,
        },
        printButtonVisible && {
            id: '6',
            label: 'Print TRF',
            icon: <PrintIcon />,
            onClick: headerPrintButtonHandler,
        },
        testEquipmentSection && {
            id: '7',
            label: 'Test Equipment Inventory',
            icon: <BuildIcon />,
            onClick: testEquipmentSection,
        },
        (currentAppView === 'home' || currentAppView === 'lateEntryHome') && {
            id: '8',
            label: 'User Guide',
            icon: <InfoIcon />,
            onClick: () => {
                if (headerInfoButtonHandler) headerInfoButtonHandler();
            },
        },
        isMRATOnline && {
            id: '9',
            label: 'Log Out',
            icon: <AccountCircleIcon />,
            onClick: headerLogOutButtonHandler,
        }
    ].filter(Boolean);

    const tooltipClasses = useTooltipStyles();
    const NotificationBadge = withStyles(() => ({
        badge: {
            backgroundColor: 'rgb(234, 124, 52)',
            color: '#fff',
            top: '-14px',
            right: '12px',
            minWidth: 16,
            height: 16,
            padding: '0 2px',
            fontSize: '0.55rem',
            fontWeight: 600,
            borderRadius: 8,
            boxShadow: '0 0 0 0.5px #fff'
        }
    }))(Badge);

    const unreadAnnouncementsCount = useSelector(({ Home }) => Home.unreadAnnouncementsCount);
    const notificationCount = unreadAnnouncementsCount > 99 ? '99+' : unreadAnnouncementsCount;

    return (
        <>
            <Tooltip title="More actions" placement="bottom" classes={{ tooltip: tooltipClasses.tooltip }}>
                <StyledMoreVertIcon
                    onClick={handleMenuOpen}
                    style={{ fontSize: '2.2rem', cursor: 'pointer' }}
                />
            </Tooltip>
            {(currentAppView === 'home' || currentAppView === 'lateEntryHome') && (
                <span style={{ position: 'relative', display: 'inline-flex' }}>
                    <NotificationBadge
                        badgeContent={notificationCount}
                        overlap="circle"
                        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                        invisible={!notificationCount || notificationCount === 0}
                    />
                </span>
            )}
            <Menu
                id="ellipses-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
                style={{ marginTop: '40px' }}
            >
                {menuItems.map((item) => (
                    <MenuItem key={item.id || item.label} style={{ fontSize: '9pt' }} onClick={() => handleItemClick(item.onClick)}>
                        {item.icon && <span style={{ marginRight: 8 }}>{item.icon}</span>}
                        {item.label && <span style={{ fontSize: '0.8rem' }}>{item.label}</span>}
                        {item.notification && unreadAnnouncementsCount > 0 && (currentAppView === 'home' || currentAppView === 'lateEntryHome') && (
                            <span style={{ position: 'relative', display: 'inline-flex' }}>
                                <NotificationBadge
                                    badgeContent={notificationCount}
                                    overlap="circle"
                                    style={{ marginLeft: '30px', marginTop: '25px' }}
                                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                                    invisible={!notificationCount || notificationCount === 0}
                                />
                            </span>
                        )}
                    </MenuItem>
                ))}
            </Menu>
            {clickedButton === 'Announcements' && (
                <AnnouncementDialog open={dialogOpen} onClose={() => setDialogOpen(false)} />
            )}
        </>
    );
};

const mapStateToProps = ({ Home }) => ({
    currentAppView: Home.currentView,
    bpRegionNameAlias: Home.bpRegionNameAlias,
    IsLateEntry: Home.IsLateEntry,
});

const mapDispatchToProps = dispatch => ({
    dispatch,
    setCurrentAppView: (view) => dispatch(setCurrentView(view)),
    setLateEntryUserStatus: (status) => dispatch(setLateEntryStatus(status)),
});

EllipsesMenu.propTypes = {
    bpRegionNameAlias: PropTypes.string,
    currentAppView: PropTypes.string,
    dpsSection: PropTypes.any,
    headerInfoButtonHandler: PropTypes.func,
    headerLogOutButtonHandler: PropTypes.func,
    headerPrintButtonHandler: PropTypes.func,
    IsLateEntry: PropTypes.bool,
    isMRATOnline: PropTypes.bool,
    onClassicAppClick: PropTypes.func,
    printButtonVisible: PropTypes.bool,
    setColorLedgerVisible: PropTypes.func,
    setCurrentAppView: PropTypes.func,
    setLateEntryUserStatus: PropTypes.func,
    testEquipmentSection: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(EllipsesMenu);
